import React from "react";
import styled, { css } from "styled-components";

export const copyStyles = css`
  font-size: 16px;
  line-height: 24px;
  font-family: ${({ theme }) => theme.fontFamily};
  color: ${({ theme, $colour }) =>
    $colour === "white" ? theme.colours.white : theme.colours.black};
  margin-bottom: 20px;

  @media (min-width: 768px) {
    font-size: 20px;
    line-height: 30px;
  }
  
  ul {
    list-style: disc inside;
  }

  ol {
    list-style: decimal inside;
  }

  li::marker {
    color: #2116CA;
  }

  a {
    text-decoration: "none";
    font-family: ${({ theme }) => theme.fontFamilyBold};
    font-weight: 700;
    color: ${({ theme, $colour }) =>
      $colour === "white" ? theme.colours.white : theme.colours.blue};
  }

  strong {
    font-family: ${({ theme }) => theme.fontFamilyBold};
    font-weight: 700;
  }

  p {
    margin-bottom: 1em;
  }
`;

export const BaselineCopy = styled.div`
  ${copyStyles}
`;

const SmallCopy = styled(BaselineCopy)`
  font-size: 14px;
  line-height: 20px;

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

const MediumCopy = styled(BaselineCopy)`
  font-size: 22px;
  line-height: 28px;

  @media (min-width: 768px) {
    font-size: 20px;
    line-height: 30px;
  }
`;

const LargeCopy = styled(BaselineCopy)`
  font-size: 30px;
  line-height: 34px;
`;

export const Paragraph = styled.p`
  font-size: 16px;
  line-height: 24px;
  font-family: ${({ theme }) => theme.fontFamily};
  color: ${({ theme, $colour }) =>
    $colour ? theme.colours[$colour] : theme.colours.black};
  margin-bottom: 1em;

  @media (min-width: 768px) {
    font-size: 20px;
    line-height: 30px;
  }

  a {
    text-decoration: "none";
    font-family: ${({ theme }) => theme.fontFamilyBold};
    font-weight: 700;
    color: ${({ theme, $colour }) =>
      $colour === "white" ? theme.colours.white : theme.colours.blue};
  }

  strong {
    font-family: ${({ theme }) => theme.fontFamilyBold};
    font-weight: 700;
  }
`;

export function Copy({
  children,
  isMarkdown = true,
  small,
  medium,
  large,
  colour,
}) {
  if (isMarkdown && !children?.childMarkdownRemark) {
    console.warn("Copy component requires markdown");
    return null;
  }

  if (!isMarkdown) {
    return <Paragraph $colour={colour}>{children}</Paragraph>;
  }

  let CopyComponent = BaselineCopy;

  if (small) {
    CopyComponent = SmallCopy;
  } else if (medium) {
    CopyComponent = MediumCopy;
  } else if (large) {
    CopyComponent = LargeCopy;
  }

  return (
    <CopyComponent
      $colour={colour}
      dangerouslySetInnerHTML={{
        __html: children?.childMarkdownRemark?.html,
      }}
    />
  );
}
